// src/api/categories.ts
import { apiClient } from './client';

export interface Category {
    id: number;
    name: string;
    is_active: boolean;
    created_at: string;
}

export interface CategorySearchResponse {
    id: number;
    name: string;
}

export const categoriesAPI = {
    /**
     * Get all categories (with pagination)
     */
    getCategories: async (params?: {
        page?: number;
        page_size?: number;
        is_active?: boolean;
    }) => {
        try {
            const response = await apiClient.get('/store/categories/', { params });
            return { data: response.data, error: null };
        } catch (error: any) {
            return {
                data: null,
                error: error.response?.data?.detail || 'Failed to fetch categories'
            };
        }
    },

    /**
     * Search categories by name (for autocomplete)
     */
    searchCategories: async (query: string, limit: number = 15) => {
        try {
            if (!query || query.length < 2) {
                return { data: [], error: null };
            }

            const response = await apiClient.get('/store/categories/search/', {
                params: { q: query, limit }
            });
            return { data: response.data, error: null };
        } catch (error: any) {
            return {
                data: [],
                error: error.response?.data?.detail || 'Failed to search categories'
            };
        }
    },

    /**
     * Get popular/active categories (for initial dropdown)
     */
    getPopularCategories: async (limit: number = 20) => {
        try {
            const response = await apiClient.get('/store/categories/popular/', {
                params: { limit }
            });
            return { data: response.data, error: null };
        } catch (error: any) {
            return {
                data: [],
                error: error.response?.data?.detail || 'Failed to fetch popular categories'
            };
        }
    },
};